// ACQ129
export let PricingTier;

(function (PricingTier) {
  PricingTier["Free"] = "FREE";
  PricingTier["Starter"] = "STARTER";
  PricingTier["Professional"] = "PROFESSIONAL";
})(PricingTier || (PricingTier = {}));